<template>
  <div class="app-logo" v-bind="$attrs">
    <router-link :to="{ name: 'dashboard' }" class="site-logo-img pt-3">
      <img :src="brand.appLogo" alt="GreenGeeks Web Hosting">
    </router-link>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'AppLogo',

  computed: {
    ...mapGetters(['brand']),
  }
}
</script>
